import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  withStyles,
  IconButton,
  Tooltip,
} from '@material-ui/core'
import { ExpandMore, Info } from '@material-ui/icons'
import styles from 'components/AddOrEditFormPage/Form/styles'
import { toggleFormDataPanel } from 'actions/campaign/addOrEdit'
import classNames from 'classnames'
import Heading from './Heading'

export default connect(
  (state, { idx }) => {
    if (idx > 0) {
      if (idx < 2) {
        return {
          expanded: state.campaign.addOrEdit.expanded[idx],
          prevExpanded: state.campaign.addOrEdit.expanded[idx - 1],
          nextExpanded: state.campaign.addOrEdit.expanded[idx + 1],
        }
      } else {
        return {
          expanded: state.campaign.addOrEdit.expanded[idx],
          prevExpanded: state.campaign.addOrEdit.expanded[idx - 1],
        }
      }
    }
    return {
      expanded: state.campaign.addOrEdit.expanded[idx],
      nextExpanded: state.campaign.addOrEdit.expanded[idx + 1],
    }
  },
  dispatch => bindActionCreators({ toggleFormDataPanel }, dispatch),
)(
  withStyles(styles)(
    ({
      classes,
      children,
      title,
      disabled,
      expanded,
      prevExpanded,
      nextExpanded,
      toggleFormDataPanel,
      idx,
      toolTip,
    }) => {
      const style = () => {
        if (expanded) {
          return null
        } else {
          if ((prevExpanded || idx === 0) && (nextExpanded || idx === 2)) {
            return { borderRadius: 35 }
          } else if (prevExpanded || idx === 0) {
            return { borderTopLeftRadius: 35, borderTopRightRadius: 35 }
          } else if (nextExpanded || idx === 2) {
            return { borderBottomLeftRadius: 35, borderBottomRightRadius: 35 }
          } else {
            return null
          }
        }
      }

      const Icon = Info

      return (
        <ExpansionPanel
          expanded={expanded}
          classes={{
            expanded: classes.expansionPanelExpanded,
          }}
          onChange={() => toggleFormDataPanel(idx)}
          style={style()}
        >
          <ExpansionPanelSummary
            classes={{
              expandIcon: classes.expandIcon,
              expanded: classes.expansionPanelSummaryExpanded,
            }}
            className={
              disabled
                ? classes.expansionPanelSummaryDisabled
                : classes.expansionPanelSummary
            }
            expandIcon={<ExpandMore />}
            style={style()}
          >
            <Heading title={title} />
            <Tooltip title={toolTip}>
              <IconButton
                disableRipple
                disableTouchRipple
                style={{ padding: 0 }}
                className={classNames(
                  classes.headingIcon,
                  classes.color,
                )}
              >
                <Icon className={classes.icon} />
              </IconButton>
            </Tooltip>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails
            style={
              prevExpanded && !expanded
                ? { backgroundColor: 'transparent', padding: '15px 24px 24px' }
                : { padding: '15px 24px 24px' }
            }
          >
            {children}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      )
    },
  ),
)
